import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/tenantDepartmentSlice";
import tenantDepartmentApis from "src/api/tenantDepartment";
import { common } from "src/types";
import { constants } from "src/constants/common";

// ✅ Create Department Saga
function* CreateTenantDepartmentSaga({
  payload,
}: ReturnType<typeof actions.createTenantDepartmentRequest> & {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantDepartmentApis.createTenantDepartment,
      payload
    );
    yield put(actions.createTenantDepartmentSuccess(response?.data));
  } catch (error) {
    yield put(
      actions.createTenantDepartmentError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Get Department List Saga
function* GetTenantDepartmentListSaga({
  payload,
}: ReturnType<typeof actions.getTenantDepartmentListRequest> & {
  payload: { page?: number; limit: number; search?: string };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantDepartmentApis.getTenantDepartmentList,
      payload
    );
    yield put(actions.getTenantDepartmentListSuccess(response));
  } catch (error) {
    yield put(
      actions.getTenantDepartmentListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Edit Department Saga
function* EditTenantDepartmentSaga({
  payload,
}: ReturnType<typeof actions.editTenantDepartmentRequest> & {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantDepartmentApis.editTenantDepartment,
      payload
    );
    yield put(actions.editTenantDepartmentSuccess(response?.data));
  } catch (error) {
    yield put(
      actions.editTenantDepartmentError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Delete Department Saga
function* DeleteTenantDepartmentSaga({
  payload,
}: ReturnType<typeof actions.deleteTenantDepartmentRequest> & {
  payload: string;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantDepartmentApis.deleteTenantDepartment,
      payload
    );
    yield put(actions.deleteTenantDepartmentSuccess(response));
  } catch (error) {
    yield put(
      actions.deleteTenantDepartmentError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* tenantDepartmentSaga() {
  yield all([
    takeEvery(
      actions.createTenantDepartmentRequest,
      CreateTenantDepartmentSaga
    ),
    takeEvery(
      actions.getTenantDepartmentListRequest,
      GetTenantDepartmentListSaga
    ),
    takeEvery(actions.editTenantDepartmentRequest, EditTenantDepartmentSaga),
    takeEvery(
      actions.deleteTenantDepartmentRequest,
      DeleteTenantDepartmentSaga
    ),
  ]);
}
